import { USER_INSTANCE_SPACE } from '../../../constants/user-data-model';
import type { Group } from '../types';

import { useUserGroupsQuery } from './use-user-groups-query';
import {
  extractSpaceIdsRead,
  extractSpaceIdsWrite,
  hasGroupWithScopeAllRead,
} from './utils';

export const selectUserSpaceAccess = (groups: Group[]): boolean => {
  const hasReadAllSpacesAccess = hasGroupWithScopeAllRead(groups);
  const spaceIdsWithReadAccess = extractSpaceIdsRead(groups);
  const spaceIdsWithWriteAccess = extractSpaceIdsWrite(groups);

  return (
    hasReadAllSpacesAccess ||
    (Boolean(spaceIdsWithReadAccess.includes(USER_INSTANCE_SPACE)) &&
      Boolean(spaceIdsWithWriteAccess.includes(USER_INSTANCE_SPACE)))
  );
};

export const useUserSpaceAccess = () => {
  return useUserGroupsQuery<boolean>(selectUserSpaceAccess);
};
